const theme = {
  colors: {
    // Primary colors
    primary: '#291759', // Deep purple (from homepage)
    primaryLight: '#858CD3', // Light purple (from homepage)
    primaryDark: '#1A0F3C', // Darker version of primary
    
    // Secondary colors
    secondary: '#2196F3', // Blue
    secondaryLight: '#64B5F6',
    secondaryDark: '#1976D2',
    
    // Accent colors
    accent: '#6C63FF', // Purple accent
    accentLight: '#9D97FF',
    accentDark: '#4D44FF',
    
    // Neutrals
    background: '#F2F5F8', // Light blue-gray from homepage
    surface: '#FFFFFF',
    textPrimary: '#212121',
    textSecondary: '#757575',
    border: '#E0E0E0',
    
    // Status colors
    success: '#4CAF50',
    error: '#F44336',
    warning: '#FF9800',
    info: '#2196F3',
    
    // Other colors
    disabled: '#BDBDBD',
    placeholder: '#9E9E9E'
  },
  
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      md: '1.125rem',
      lg: '1.25rem',
      xl: '1.5rem',
      xxl: '2rem',
      xxxl: '2.5rem'
    },
    weights: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700
    }
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '1rem',
    xl: '2rem',
    pill: '999px'
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14)',
    md: '0 3px 6px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12)',
    lg: '0 10px 20px rgba(0, 0, 0, 0.15), 0 3px 6px rgba(0, 0, 0, 0.1)',
    xl: '0 15px 25px rgba(0, 0, 0, 0.15), 0 5px 10px rgba(0, 0, 0, 0.05)'
  },
  
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  },
  
  transition: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
    slow: 'all 0.5s ease'
  }
};

export default theme; 